<div class="page">
    <div class="page-body" *ngIf="response.status == 1">
        <div class="page-title" *ngIf="page.mostrar_titulo">
            <div class="container">
                <h1 class="wow slideInUp">{{page.titulo}}</h1>
            </div>
        </div>
        <div class="page-content">
            <section class="section section-description wow fadeIn">
                <div class="container">
                    <div class="row"> 
                        <div class="col-md-12">
                            <article [innerHtml]="page.texto | safeHtml"></article>
                        </div>    
                    </div>    
                </div>
            </section>
            <section class="section section-conexoes">
                <div class="section-title">
                    <div class="container">
                        <h2 class="wow slideInUp">Faça parte de um Grupo de Conexão.</h2>
                        <h3 class="wow slideInLeft" data-wow-delay="0.3s">Escolha o melhor dia para você.</h3>
                        <div class="dias wow fadeIn" data-wow-delay="0.2s">
                            <div class="item wow slideUp" *ngFor="let c of conexoes" (click)="toSection(c.id)">
                                <span>{{c.titulo}}</span>
                            </div>    
                        </div>    
                    </div>
                </div>    
                <div class="section-content">
                    <div class="container">
                        <div class="list-dias">                             
                            <div class="item" *ngFor="let c of conexoes" id="section-{{c.id}}">
                                <h3>{{c.titulo}}</h3>
                                <div class="row">
                                    <div class="col-md-4" *ngFor="let i of c.conexoes">
                                        <conexao-item [data]="i"></conexao-item>
                                    </div>
                                </div>    
                            </div>
                        </div>    
                    </div>
                </div>
            </section>
        </div>  
    </div>  
    <div class="page-body" *ngIf="response.status == 500">
        <page-error (reload)="getData()"></page-error>   
    </div>  
</div>    
<loader *ngIf="loader"></loader>